import { getOrderMarkList, OrderMark } from "@/services/api/setting/orderMark";
import { computed, observable, makeObservable, actionBound } from "mobx";

/**
 * 订单标记
 */
export default class OrderMarkStore {
    constructor() {
        makeObservable(this, {
            isInit: observable,
            loading: observable,
            list: observable,
            listSkipDeleted: computed,
            mapping: computed,
            loadList: actionBound,
        });
    }

    isInit = false;

    loading = false;

    list: OrderMark[] = [];

    get listSkipDeleted() {
        return this.list?.filter((it) => !it?.deleted);
    }

    get mapping() {
        const mapping = new Map<number, OrderMark>();

        this.list.forEach((orderMark) => {
            mapping.set(orderMark.id, orderMark);
        });

        return mapping;
    }

    async loadList(isRefresh?: boolean) {
        if (this.isInit) {
            if (!isRefresh) {
                return this.list;
            }
        }

        this.loading = true;

        const list = await getOrderMarkList();

        this.list = list;

        this.isInit = true;

        this.loading = false;

        return list;
    }
}
